if (!customElements.get('free-shipping-bar')) {
  // Formats cents with the shop's money format, e.g. "{{amount_no_decimals}} kr".
  const formatMoney = (cents, format) => {
    const number = (value, decimals, thousands = ',', decimal = '.') => {
      const [whole, fraction] = (value / 100).toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, placeholder) => {
      switch (placeholder) {
        case 'amount_no_decimals':
          return number(cents, 0);
        case 'amount_with_comma_separator':
          return number(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return number(cents, 0, '.', ',');
        case 'amount_no_decimals_with_space_separator':
          return number(cents, 0, ' ');
        case 'amount_with_space_separator':
          return number(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return number(cents, 2, ' ', '.');
        case 'amount_with_apostrophe_separator':
          return number(cents, 2, "'", '.');
        default:
          return number(cents, 2);
      }
    });
  };

  customElements.define(
    'free-shipping-bar',
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold);
        this.message = this.querySelector('.free-shipping-bar__message');
        this.fill = this.querySelector('.free-shipping-bar__fill');

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      async onCartUpdate(event) {
        // Some cart updates carry the full cart; otherwise fetch it.
        let cart = event?.cartData;
        if (!cart || typeof cart.total_price !== 'number' || typeof cart.item_count !== 'number') {
          try {
            const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
            cart = await response.json();
          } catch (error) {
            return;
          }
        }
        this.render(cart);
      }

      render(cart) {
        const remaining = Math.max(this.threshold - cart.total_price, 0);
        const percent = Math.min((cart.total_price / this.threshold) * 100, 100);

        this.hidden = cart.item_count === 0;
        this.classList.toggle('is-complete', remaining === 0);
        this.fill.style.width = `${percent}%`;

        if (remaining === 0) {
          this.message.textContent = this.dataset.success;
          return;
        }

        // Build "text [belopp] text" without innerHTML so the setting text stays plain text.
        const [before, ...after] = this.dataset.message.split('[belopp]');
        const amount = document.createElement('strong');
        amount.textContent = formatMoney(remaining, this.dataset.moneyFormat);
        this.message.replaceChildren(before, ...(after.length ? [amount, after.join('[belopp]')] : []));
      }
    }
  );
}
